import React, { useState, useEffect } from 'react';

const GA_ID = 'G-Y464E3M5FX';

function loadGA() {
  if (document.getElementById('ga-script')) return;
  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);
}

function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      loadGA();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem('cookieConsent', 'accepted');
    loadGA();
    setVisible(false);
  }

  function handleReject() {
    localStorage.setItem('cookieConsent', 'rejected');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p className="cookie-text">
        We use Google Analytics to understand how people use this site. No personal data is sold or shared.
      </p>
      <div className="cookie-btns">
        <button className="cookie-accept" onClick={handleAccept}>Accept</button>
        <button className="cookie-reject" onClick={handleReject}>Reject</button>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
